(function(){
  var root=document.querySelector('.nk-page');
  if(!root) return;
  var CART_ADD=root.dataset.cartAdd||'/cart/add.js';
  var CART_URL=root.dataset.cartUrl||'/cart';
  var SYM=root.dataset.moneySymbol||'$';
  /* HulkApps pricing-app property keys — option_names from v1_variant_data. */
  var WEIGHT_KEY=root.dataset.weightKey||'Diamond Weight';
  var PURITY_KEY=root.dataset.purityKey||'Gold Purity';

  function money(cents){
    var n=Math.round(cents)/100;
    var s=(Math.round(n*100)/100).toFixed(2);
    if(s.slice(-3)==='.00') s=s.slice(0,-3);
    var parts=s.split('.');
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return SYM+parts.join('.');
  }

  /* ---------- variant_data (Weight → Gold Purity) ---------- */
  var vd=null;
  try{ var rawEl=document.getElementById('nk-variant-data'); var raw=rawEl?rawEl.textContent:''; vd=raw?JSON.parse(raw):null; }catch(e){ vd=null; }
  var weightOpts=(vd && vd.variant_data && vd.variant_data[0] && vd.variant_data[0].options)?vd.variant_data[0].options:[];

  /* ---------- gallery: thumbnail swap (image + video) ---------- */
  var stage=root.querySelector('.nk-stage');
  var mainImg=root.querySelector('#nk-main-img');
  var mainVid=root.querySelector('#nk-main-video');

  function clearVideo(){
    if(!mainVid) return;
    try{ mainVid.pause(); }catch(e){}
    mainVid.removeAttribute('src');
    mainVid.load && mainVid.load();
  }

  var thumbs=[].slice.call(root.querySelectorAll('.nk-thumb'));
  function activateThumb(t){
    if(!t) return;
    thumbs.forEach(function(x){x.classList.remove('sel');});
    t.classList.add('sel');
    setTab('photos');
    var kind=t.dataset.nkKind;
    if(kind==='video'){
      if(mainVid && t.dataset.nkVideo){
        mainVid.src=t.dataset.nkVideo;
        mainVid.poster=t.dataset.nkPoster||'';
        stage && stage.classList.add('is-video');
        mainVid.play().catch(function(){});
      }
    } else {
      clearVideo();
      stage && stage.classList.remove('is-video');
      if(mainImg && t.dataset.nkFull){ mainImg.src=t.dataset.nkFull; mainImg.alt=t.dataset.nkAlt||mainImg.alt; }
    }
    /* keep the active thumb visible in the rail */
    try{ t.scrollIntoView({block:'nearest',inline:'nearest'}); }catch(e){}
  }
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){ activateThumb(t); });
  });

  /* ---------- gallery: prev/next arrows + touch swipe (cycle images & videos) ---------- */
  function currentThumbIdx(){
    for(var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('sel')) return i; }
    return 0;
  }
  function goRelative(delta){
    if(thumbs.length<2) return;
    var idx=(currentThumbIdx()+delta+thumbs.length)%thumbs.length;
    activateThumb(thumbs[idx]);
  }
  var navPrev=root.querySelector('[data-nk-nav="prev"]');
  var navNext=root.querySelector('[data-nk-nav="next"]');
  if(navPrev) navPrev.addEventListener('click',function(e){ e.preventDefault(); goRelative(-1); });
  if(navNext) navNext.addEventListener('click',function(e){ e.preventDefault(); goRelative(1); });
  /* nothing to cycle through -> hide the arrows */
  if(thumbs.length<2){ if(navPrev) navPrev.hidden=true; if(navNext) navNext.hidden=true; }

  /* touch swipe on the main image (mobile): left = next, right = prev */
  var gmain=root.querySelector('.nk-gmain');
  if(gmain && thumbs.length>1){
    var swX=0, swY=0, swiping=false;
    gmain.addEventListener('touchstart',function(e){
      if(stage && stage.classList.contains('is3d')){ swiping=false; return; }
      var t=e.changedTouches[0]; swX=t.clientX; swY=t.clientY; swiping=true;
    },{passive:true});
    gmain.addEventListener('touchend',function(e){
      if(!swiping) return; swiping=false;
      var t=e.changedTouches[0];
      var dx=t.clientX-swX, dy=t.clientY-swY;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.4){ goRelative(dx<0?1:-1); }
    },{passive:true});
  }

  /* ---------- gallery: photos / 3D tabs ---------- */
  var iframe=root.querySelector('.nk-3d');
  function setTab(which){
    root.querySelectorAll('.nk-gtab').forEach(function(b){ b.classList.toggle('sel', b.dataset.nkTab===which); });
    if(!stage) return;
    if(which==='3d'){
      if(iframe && !iframe.src && iframe.dataset.embed3d){ iframe.src=iframe.dataset.embed3d; }
      stage.classList.remove('is-video');
      clearVideo();
      stage.classList.add('is3d');
    } else {
      stage.classList.remove('is3d');
    }
  }
  root.querySelectorAll('.nk-gtab').forEach(function(b){
    b.addEventListener('click',function(){ setTab(b.dataset.nkTab); });
  });

  /* ---------- pricing: live preview from v1_variant_data (USD dollars) ----------
     Total $ = variant.price (cents) + (weight.price + purity.price) * 100
     Same for compare_at. */
  var base=parseInt(root.dataset.price||'0',10);          // cents
  var compare=parseInt(root.dataset.compare||'0',10);     // cents
  var nowEl=root.querySelector('#nk-price-now');
  var wasEl=root.querySelector('#nk-price-was');
  var saveEl=root.querySelector('#nk-save');
  var weightLab=root.querySelector('#nk-weight-label');
  var purityLab=root.querySelector('#nk-purity-label');
  var specWeight=root.querySelector('#nk-spec-weight');
  var specPurity=root.querySelector('#nk-spec-purity');
  var specLength=root.querySelector('#nk-spec-length');
  var mbarPrice=root.querySelector('#nk-mbar-price');var mbarWas=root.querySelector('#nk-mbar-was');
  var mbarMeta=root.querySelector('#nk-mbar-meta');

  function currentWeightIdx(){ var a=root.querySelector('.nk-chip.active'); return a?parseInt(a.dataset.nkWeightIdx||'0',10):0; }
  function currentPurityIdx(){ var a=root.querySelector('[data-nk-purity].active'); return a?parseInt(a.dataset.nkPurityIdx||'0',10):0; }
  function currentSize(){ var s=root.querySelector('[data-nk-size]'); return s?(s.value||'18'):'18'; }

  function rebuildPurityChoices(){
    /* Each carat option carries its own optionData.Options (10K/14K/18K) — refresh the pill row. */
    var wIdx=currentWeightIdx();
    var w=weightOpts[wIdx]; if(!w) return;
    var purityOpts=(w.optionData && w.optionData[0] && w.optionData[0].Options)||[];
    var wrap=root.querySelector('[data-nk-group="purity"]');
    if(!wrap) return;
    var prevActive=wrap.querySelector('.nk-pill.active');
    var prevIdx=prevActive?parseInt(prevActive.dataset.nkPurityIdx||'0',10):0;
    if(prevIdx>=purityOpts.length) prevIdx=0;
    wrap.innerHTML='';
    purityOpts.forEach(function(p,i){
      var btn=document.createElement('button');
      btn.type='button';
      btn.className='nk-pill'+(i===prevIdx?' active':'');
      btn.setAttribute('data-nk-purity',p.name);
      btn.setAttribute('data-nk-purity-idx',String(i));
      btn.textContent=p.name;
      btn.addEventListener('click',function(){
        wrap.querySelectorAll('.nk-pill').forEach(function(x){x.classList.remove('active');});
        btn.classList.add('active');
        recompute();
      });
      wrap.appendChild(btn);
    });
  }

  /* Returns the per-unit price snapshot the cart needs:
       { now, was, weight, purity }      — cents in shop currency.
     Pricing-app reads `now` from properties[_DynamicPrice] and overrides the line price. */
  function currentSelection(){
    if(!weightOpts.length){ return null; }
    var w=weightOpts[currentWeightIdx()]; if(!w) return null;
    var purityOpts=(w.optionData && w.optionData[0] && w.optionData[0].Options)||[];
    var purity=purityOpts[Math.min(currentPurityIdx(),purityOpts.length-1)]||purityOpts[0];
    var addP=((w.price||0)+(purity&&purity.price||0))*100;
    var addCompare=(((w.compare_at_price)||(w.price)||0)+((purity&&purity.compare_at_price)||(purity&&purity.price)||0))*100;
    var rate=(window.Shopify&&Shopify.currency&&Shopify.currency.rate)?Number(Shopify.currency.rate)||1:1;
    return {
      now:    Math.round((base+addP)*rate),
      was:    compare>0?Math.round((compare+(addCompare>addP?addCompare:addP))*rate):0,
      weight: w,
      purity: purity
    };
  }

  function recompute(){
    var sel=currentSelection(); if(!sel) return;
    var w=sel.weight, purity=sel.purity;
    var now=sel.now, was=sel.was;

    if(nowEl) nowEl.textContent=money(now);
    if(mbarPrice) mbarPrice.textContent=money(now);if(mbarWas) mbarWas.textContent=money(now*2);
    if(wasEl && was>0){
      wasEl.textContent=money(was);
      if(saveEl){ var off=was>0?Math.round((was-now)/was*100):0; saveEl.textContent='Save '+off+'%'; }
    }

    if(weightLab) weightLab.textContent=w.name;
    if(specWeight) specWeight.textContent=w.name;
    if(purity){
      if(purityLab) purityLab.textContent=purity.name;
      if(specPurity) specPurity.textContent=purity.name;
    }
  }

  /* wire carat-weight chips */
  root.querySelectorAll('.nk-chip').forEach(function(p){
    p.addEventListener('click',function(){
      root.querySelectorAll('.nk-chip').forEach(function(x){x.classList.remove('active');});
      p.classList.add('active');
      rebuildPurityChoices();
      recompute();
      syncMbarMeta();
    });
  });
  /* wire purity pills (initial) */
  root.querySelectorAll('[data-nk-purity]').forEach(function(p){
    p.addEventListener('click',function(){
      root.querySelectorAll('[data-nk-purity]').forEach(function(x){x.classList.remove('active');});
      p.classList.add('active');
      recompute();
    });
  });

  /* chain-length <select> — sync the spec readout and mobile-bar meta */
  var lenSel=root.querySelector('[data-nk-size]');
  function syncMbarMeta(){
    if(!mbarMeta) return;
    var w=root.querySelector('.nk-chip.active');
    var len=lenSel?lenSel.value+'"':'';
    var bits=[];
    if(w) bits.push(w.dataset.nkWeight);
    if(len) bits.push(len);
    mbarMeta.textContent=bits.length?bits.join(' · '):mbarMeta.textContent;
  }
  if(lenSel){
    lenSel.addEventListener('change',function(){
      if(specLength) specLength.textContent=lenSel.value+'"';
      syncMbarMeta();
    });
  }

  /* ---------- quantity stepper ---------- */
  var qty=root.querySelector('#nk-qty');
  root.querySelectorAll('[data-nk-qty]').forEach(function(b){
    b.addEventListener('click',function(){
      if(!qty) return;
      var step=parseInt(b.dataset.nkQty||'1',10);
      var v=Math.max(1,Math.min(20,(parseInt(qty.value||'1',10)||1)+step));
      qty.value=String(v);
    });
  });
  if(qty){ qty.addEventListener('change',function(){
    var v=Math.max(1,Math.min(20,parseInt(qty.value||'1',10)||1));
    qty.value=String(v);
  }); }

  /* ---------- add to bag ---------- */
  var toast=root.querySelector('#nk-toast');
  function showToast(){
    if(!toast) return;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t=setTimeout(function(){ toast.classList.remove('show'); }, 3200);
  }

  var addBtn=root.querySelector('[data-nk-add]');
  if(addBtn){
    addBtn.addEventListener('click',function(){
      var vid=root.dataset.variantId;
      if(!vid) return;
      var w=root.querySelector('.nk-chip.active');
      var pu=root.querySelector('[data-nk-purity].active');
      var sz=currentSize();
      var sel=currentSelection();

      var props={};
      if(w) props[WEIGHT_KEY]=w.dataset.nkWeight;
      if(pu) props[PURITY_KEY]=pu.dataset.nkPurity;
      if(sz) props['Chain Length']=sz+'"';

      /* HulkApps pricing-app hand-off — the cart-transform reads these and overrides the
         line-item price. Without them the cart charges the variant's default base price
         (e.g. the 7-carat tier) regardless of what the customer selected on the PDP. */
      if(sel){
        props['_DynamicPrice']=String(sel.now);              /* per-unit cents */
        props['_totalPrice']=String(sel.now/100);            /* per-unit dollars */
        props['Production Method']='Regular Production';
      }

      var qv=qty?Math.max(1,parseInt(qty.value||'1',10)||1):1;
      addBtn.disabled=true;
      var label=addBtn.querySelector('span');
      var orig=label?label.textContent:'';
      if(label) label.textContent='Adding…';
      fetch(CART_ADD,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(vid),quantity:qv,properties:props}]})})
        .then(function(r){return r.json();})
        .then(function(){
          addBtn.disabled=false;
          if(label) label.textContent=orig;
          showToast();
          if(window.CartJS && window.CartJS.getCart){ try{ window.CartJS.getCart(); }catch(e){} }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function(){
          addBtn.disabled=false;
          if(label) label.textContent=orig;
        });
    });
  }

  /* ---------- Mobile sticky bar → fires the same add-to-bag flow ---------- */
  var mbarBtn=root.querySelector('[data-nk-mbar-add]');
  if(mbarBtn && addBtn){
    mbarBtn.addEventListener('click',function(){ addBtn.click(); });
  }

  /* ---------- Length Guide modal ---------- */
  var guide=root.querySelector('#nk-guide');
  function openGuide(){
    if(!guide) return;
    if(typeof guide.showModal==='function'){ try{ guide.showModal(); return; }catch(e){} }
    /* graceful fallback for old browsers w/o <dialog> */
    guide.setAttribute('open','');
    guide.classList.add('is-open');
    document.documentElement.style.overflow='hidden';
  }
  function closeGuide(){
    if(!guide) return;
    if(typeof guide.close==='function'){ try{ guide.close(); }catch(e){} }
    guide.removeAttribute('open');
    guide.classList.remove('is-open');
    document.documentElement.style.overflow='';
  }
  root.querySelectorAll('[data-nk-guide-open]').forEach(function(b){
    b.addEventListener('click',openGuide);
  });
  if(guide){
    guide.querySelectorAll('[data-nk-guide-close]').forEach(function(b){
      b.addEventListener('click',closeGuide);
    });
    /* click on backdrop closes (target === dialog itself, not its inner content) */
    guide.addEventListener('click',function(e){ if(e.target===guide) closeGuide(); });
    /* the native <dialog> ESC fires a 'cancel' event; also re-enable scroll */
    guide.addEventListener('close',function(){ document.documentElement.style.overflow=''; });
    guide.addEventListener('cancel',function(){ document.documentElement.style.overflow=''; });
  }

  /* initial render */
  recompute();
})();
